document.addEventListener('DOMContentLoaded', function () {
	 // Read more read less
	 window.readMoreLess = function() {
    document.querySelector('.mini-description .read')?.addEventListener('click', function() {
      document.querySelector('.full-description').classList.remove('hidden');
      document.querySelector('.mini-description').classList.add('hidden'); 
    });
    document.querySelector('.full-description .read')?.addEventListener('click', function() {
      document.querySelector('.full-description').classList.add('hidden');
      document.querySelector('.mini-description').classList.remove('hidden'); 
    });

    let lineCount = 6;
    let lineHeight = parseInt(window.getComputedStyle(document.querySelector('.product_description-lineclamp')).getPropertyValue('line-height'));
    let maxHeight = lineHeight * lineCount;
    let description = document.querySelector('.product_description-lineclamp');
    let text = description.innerHTML;
    let textHeight = description.offsetHeight;
    
    while (textHeight > maxHeight) {
      text = text.split(' ').slice(0, -1).join(' ');
      description.innerHTML = text + '...';
      textHeight = description.offsetHeight;
    }
  }

	if (document.querySelector('.mini-description .read')) {
		window.readMoreLess();
	}

	// More offers
	window.moreOffers = function () {
		var moreText = parseInt(document.querySelectorAll('.offer-description ul li').length - 2);

		if (document.querySelector('.more-offer') && document.querySelector('.offer-description-inner .more-offer')) {
			if (document.querySelector('.more-offer').textContent.includes('qwikcilver_gift_card')) {
				document.querySelector('.more-offer').textContent = moreText + ' more';
			} else {
				document.querySelector('.more-offer').textContent = moreText + ' more offers';
				if (moreText < 1) {
					document.querySelector('.offer-description-inner .more-offer').style.display = 'none';
				}
			}

			document.querySelector('.more-offer').addEventListener('click', function () {
				this.classList.toggle('show-less');
				if (this.classList.contains('show-less')) {
					this.textContent = 'Show less';
					document.querySelectorAll('.offer-description ul li:nth-child(n+3)').forEach(function (element) {
						element.style.display = 'block';
					});
				} else {
					if (document.querySelector('.more-offer').textContent.includes('qwikcilver_gift_card')) {
						document.querySelector('.more-offer').textContent = moreText + ' more';
					} else {
						document.querySelector('.more-offer').textContent = moreText + ' more offers';
					}
					document.querySelectorAll('.offer-description ul li:nth-child(n+3)').forEach(function (element) {
						element.style.display = 'none';
					});
				}
			});
		}
	};

	window.moreOffers();

	// Ingredients sections splide slider
	window.ingredientSlider = function () {
		const ingredientsItem = document.querySelectorAll('.ingredients-item');

		if (ingredientsItem.length > 0) {
			ingredientsItem.forEach((el) => el.classList.add('splide__slide'));

			const ingredientSplide = new Splide('.ingredients-slider', {
				mediaQuery: 'min',
				perPage: 1,
				pagination: true,
				padding: { right: 40 },
				gap: 15,
				breakpoints: {
					750: {
						perPage: 3,
						gap: 30,
						padding: { right: 0 },
					},
				},
			});

			ingredientSplide.on('pagination:mounted', function (data) {
				// You can add your class to the UL element
				data.list.classList.add('splide__pagination--custom');
				// `items` contains all dot items
				data.items.forEach(function (item) {
					item.button.textContent = String(item.page + 1) + '/' + String(data.items.length);
				});
			});

			ingredientSplide.mount();
		}
	};

	if ( document.querySelector('.ingredients-slider')) {
      window.ingredientSlider();
    }

  	window.ingredientDesktopSlider = function () {
      const ingredientsSliderDesktop = document.querySelector('.ingredients-slider-desktop');
      const ingredientsItem = ingredientsSliderDesktop.querySelectorAll('.ingredients-item');

      if (ingredientsItem.length > 0) {
        ingredientsItem.forEach((el) => el.classList.add('splide__slide'));

        const ingredientSplide = new Splide('.ingredients-slider-desktop', {
          mediaQuery: 'min',
          perPage: 1,
          pagination: true,
          padding: { right: 40 },
          gap: 15,
          breakpoints: {
              750: {
                  perPage: 3,
                  gap: 30,
                  padding: { right: 0 },
              },
          },
        });

        ingredientSplide.on('pagination:mounted', function (data) {
          // You can add your class to the UL element
          data.list.classList.add('splide__pagination--custom');
          // `items` contains all dot items
          data.items.forEach(function (item) {
            item.button.textContent = String(item.page + 1) + '/' + String(data.items.length);
          });
        });

        ingredientSplide.mount();
      }
	};

	if ( document.querySelector('.ingredients-slider-desktop')) {
      window.ingredientDesktopSlider();
    }

	// Quantity selector greter than 4 alert box
	window.qtyMaxChecker = function () {
		const quantitySelector = document.querySelector('input[name="quantity"]');
		quantitySelector.addEventListener('change', function () {
			const selectedValue = parseInt(quantitySelector.value);
			if (selectedValue > 4) {
				alert('Kindly Contact our customer Support team on WhatsApp at +91-9004436043 for bulk buying. Thank you');
				quantitySelector.value = 4;
			}
		});
	};

	window.qtyMaxChecker();

	window.varintSwicher = function () {
		function isIE() {
			const ua = window.navigator.userAgent;
			const msie = ua.indexOf('MSIE ');
			const trident = ua.indexOf('Trident/');

			return msie > 0 || trident > 0;
		}

		if (!isIE()) return;
		const hiddenInput = document.querySelector('#{{ product_form_id }} input[name="id"]');
		const noScriptInputWrapper = document.createElement('div');
		const variantSwitcher = document.querySelector('variant-radios[data-section="{{ section.id }}"]') || document.querySelector('variant-selects[data-section="{{ section.id }}"]');

		noScriptInputWrapper.innerHTML = document.querySelector('.product-form__noscript-wrapper-{{ section.id }}').textContent;

		variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

		document.querySelector('#Variants-{{ section.id }}').addEventListener('change', function (event) {
			hiddenInput.value = event.currentTarget.value;
		});
	};

	window.varintSwicher();

	// Progress bar animation
	window.progressBar = function () {
		var isInViewport = function (elem) {
			var distance = elem.getBoundingClientRect();
			return (
				distance.top >= 0 &&
				distance.left >= 0 &&
				distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				distance.right <= (window.innerWidth || document.documentElement.clientWidth)
			);
		};

		// read the link on how above code works
		// Numbers Animation
		var animateObj = document.getElementById('progressbar');

		if (animateObj) {
			var animateCount = animateObj.getAttribute('aria-valuenow') || 0;
			var inView = false;

			function animateValue(obj, start, end, duration) {
				if (!obj) return;
				let startTimestamp = null;
				const step = (timestamp) => {
					if (!startTimestamp) {
						startTimestamp = timestamp;
					}
					const progress = Math.min((timestamp - startTimestamp) / duration, 1);
					if (end % 1 === 0) {
						obj.innerHTML = Math.floor(progress * (end - start) + start) + (end > 10 ? '%' : 'X');
					} else {
						obj.innerHTML = (progress * (end - start) + start).toFixed(1) + (end > 10 ? '%' : 'X');
					}
					if (progress < 1) {
						window.requestAnimationFrame(step);
					}
				};
				window.requestAnimationFrame(step);
			}

			var findMe = document.querySelectorAll('.grow-progressbar');
			window.addEventListener(
				'scroll',
				function (event) {
					// add event on scroll
					findMe.forEach((element) => {
						//for each .thisisatest
						if (isInViewport(element) && !inView) {
							//if in Viewport
							inView = true;
							element.classList.add('in-viewport');
							animateValue(animateObj, 0, animateCount, 3000);
						}
					});
				},
				false,
			);
		}
	};

	window.progressBar();

	// Product FAQ Section open close accordion code
	window.faqInitialization = function () {
		if (document.querySelector('.panel-collapse')) {
			var coll = document.querySelectorAll('.panel-heading');
			var collapseContent = document.querySelectorAll('.panel-collapse');

			// Close all accordion sections
			collapseContent.forEach((elem) => {
				elem.style.height = '0';
				elem.style.display = 'none';
			});

			// Open the first child accordion section by default
			var firstAccordion = coll[0];
			firstAccordion.classList.add('active');
			var firstContent = firstAccordion.nextElementSibling;
			firstContent.style.height = 'auto';
			firstContent.style.display = 'block';

			// Toggle accordion sections
			coll.forEach((header) => {
				header.addEventListener('click', function () {
					if (!this.classList.contains('active')) {
						// Close currently open accordion
						var activeHeader = document.querySelector('.panel-heading.active');
						var activeContent = activeHeader.nextElementSibling;
						activeHeader.classList.remove('active');
						activeContent.style.height = '0';
						activeContent.style.display = 'none';
					} else {
						// If this.classList.contains "active"
						return false;
					}

					this.classList.toggle('active');
					var content = this.nextElementSibling;

					if (content.style.display === 'block') {
						content.style.height = '0';
						content.style.display = 'none';
					} else {
						content.style.height = 'auto';
						content.style.display = 'block';
					}
				});
			});
		}
	};

	window.faqInitialization();


	// Judge Me append Elements
	window.judgeMeAppend = function () {
		var script = document.createElement('script');

		script.innerHTML = `!function(e){window.jdgm=window.jdgm||{},jdgm.CDN_HOST="https://cdn.judge.me/",
    jdgm.docReady=function(d){(e.attachEvent?"complete"===e.readyState:"loading"!==e.readyState)?
    setTimeout(d,0):e.addEventListener("DOMContentLoaded",d)},jdgm.loadCSS=function(d,t,o,s){
    !o&&jdgm.loadCSS.requestedUrls.indexOf(d)>=0||(jdgm.loadCSS.requestedUrls.push(d),
    (s=e.createElement("link")).rel="stylesheet",s.class="jdgm-stylesheet",s.media="nope!",
    s.href=d,s.onload=function(){this.media="all",t&&setTimeout(t)},e.body.appendChild(s))},
    jdgm.loadCSS.requestedUrls=[],jdgm.loadJS=function(e,d){var t=new XMLHttpRequest;
    t.onreadystatechange=function(){4===t.readyState&&(Function(t.response)(),d&&d(t.response))},
    t.open("GET",e),t.send()},jdgm.docReady((function(){(window.jdgmLoadCSS||e.querySelectorAll(
    ".jdgm-widget, .jdgm-all-reviews-page").length>0)&&(jdgmSettings.widget_load_with_code_splitting?
    parseFloat(jdgmSettings.widget_version)>=3?jdgm.loadCSS(jdgm.CDN_HOST+"widget_v3/base.css"):
    jdgm.loadCSS(jdgm.CDN_HOST+"widget/base.css"):jdgm.loadCSS(jdgm.CDN_HOST+"shopify_v2.css"),
    jdgm.loadJS(jdgm.CDN_HOST+"loader.js"))}))}(document);`;

		document.head.appendChild(script);
	};

	//window.judgeMeAppend();

	// Share button click fucntion
	window.shareButtonFun = function () {
		var share_Btn = document.querySelector('.share_container-pills-btn');
		if (share_Btn) {
			if (navigator.share) {
				share_Btn.addEventListener('click', () => {
					var productTitle = share_Btn.getAttribute('data-title');
					var url = share_Btn.getAttribute('data-url');

					navigator.share({
						text: productTitle,
						url: url,
					})
						.then(() => console.log('Shared successfully'))
						.catch((error) => console.log('Error sharing:', error));
				});
			} else {
				// Web Share API is not supported
				share_Btn.style.display = 'none';
			}

			var deskShare_btn = document.querySelector('.d-share_container-pills-btn');

			deskShare_btn.addEventListener('click', () => {
				var closeIconSpan = deskShare_btn.querySelector('.closebtn-container');
				var shareIconSpan = deskShare_btn.querySelector('.sharebtn-container');
				var shareList = document.querySelector('.d-share_list');

				if (!deskShare_btn.classList.contains('is-open')) {
					deskShare_btn.classList.add('is-open', 'closebtn-container-active');
					closeIconSpan.classList.add('closebtn-container-active');
					shareIconSpan.classList.add('closebtn');
					shareList.classList.add('share_list-active');
				} else {
					deskShare_btn.classList.remove('is-open', 'closebtn-container-active');
					closeIconSpan.classList.remove('closebtn-container-active');
					shareIconSpan.classList.remove('closebtn');
					shareList.classList.remove('share_list-active');
				}
			});
		}
	};

	window.shareButtonFun();

	// sticky Product Section Tabs
	// window.StickyProductTabs = function () {

	//   // Store the previous scroll position
	//   let prevScrollPos = window.pageYOffset;
	//   const headerContainer = document.querySelector(".header-container");
	//   const tagFilterContainer = document.querySelector("#removeable_content");
	//   const headertagFilterContainer = document.querySelector("#removeable_content");
	//   const filterObserverElement = document.querySelector(".filter-observer-pdp");
	//   const footerObserverElement = document.querySelector(".custom-footer-section");
	//   const hasClass = headerContainer.classList.contains("js-display-none");

	//   if (!hasClass){
	//     if (filterObserverElement) {
	//       window.addEventListener("scroll", function() {
	//         const scrollPosition = (typeof window.scrollY !== 'undefined') ? window.scrollY : window.pageYOffset;
	//         const path = window.location.pathname;

	//         if (scrollPosition > 200) {
	//           if (path.includes("search")) {
	//             headerContainer.style.display = 'none';
	//           }else {
	//             toggleDivVisibility();
	//             headerContainer.style.display = 'block';
	//           }
	//         } else {
	//           headerContainer.style.display = 'none';
	//         }
	//       });

	//       // Function to toggle the visibility of the div
	//       function toggleDivVisibility() {
	//         if (filterObserverElement.classList.contains("js-observed")){
	//           return;
	//         }
	//         let variableTest = false;
	//         const observer1 = new IntersectionObserver((entries) => {
	//           entries.forEach((entry) => {
	//             if (
	//               entry.target === filterObserverElement &&
	//               entry.isIntersecting &&
	//               headerContainer.contains(headertagFilterContainer)
	//             ) {
	//               headertagFilterContainer.remove();
	//               filterObserverElement.innerHTML = "";
	//               filterObserverElement.appendChild(tagFilterContainer);
	//             } else if (
	//               entry.target === filterObserverElement &&
	//               !entry.isIntersecting &&
	//               !headerContainer.contains(headertagFilterContainer)
	//             ) {
	//               headerContainer.appendChild(headertagFilterContainer);
	//               // scrollElementToCenter();
	//               variableTest = true;
	//             } else if (
	//               entry.target === footerObserverElement &&
	//               entry.isIntersecting &&
	//               headerContainer.contains(headertagFilterContainer)
	//             ) {
	//             } else if (
	//               entry.target === footerObserverElement &&
	//               !entry.isIntersecting &&
	//               !headerContainer.contains(headertagFilterContainer) &&
	//               variableTest
	//             ) {
	//               headerContainer.appendChild(headertagFilterContainer);
	//               // scrollElementToCenter();
	//             }
	//           });
	//         });

	//         // Start observing both elements
	//         observer1.observe(filterObserverElement);
	//         observer1.observe(footerObserverElement);
	//         filterObserverElement.classList.add("js-observed");
	//         footerObserverElement.classList.add("js-observed");
	//       }
	//     }

	//     const tabItems = document.querySelectorAll('.sticky-tab-item');

	//     // Add a click event listener to each list item
	//     tabItems.forEach(item => {
	//       item.addEventListener('click', function() {
	//         // Remove the 'active' class from all list items
	//         tabItems.forEach(item => {
	//             item.classList.remove('active-tab');
	//         });

	//         // Add the 'active' class to the clicked list item
	//         this.classList.add('active-tab');
	//       });
	//     });
	//   }
	// }

	// window.StickyProductTabs();

	// PDP section list scroll to section
	window.scrollToSection = function () {
		var navItems = document.querySelectorAll('.pdp-content-nav li');

		navItems.forEach(function (navItem) {
			navItem.addEventListener('click', function () {
				var targetDiv = navItem.getAttribute('data-target');
				var targetSection = document.querySelector('[data-section-name="' + targetDiv + '"]');

				if (targetSection) {
					// Calculate the offset to scroll to the section with a offset from the topValue
					var topValue = targetDiv === 'why-should-you-buy' ? 200 : 300;

					var offsetTop = targetSection.getBoundingClientRect().top + window.scrollY - topValue;

					window.scrollTo({
						top: offsetTop,
						behavior: 'smooth',
					});
				}
			});
		});
	};

	window.scrollToSection();

	window.customFunction = function() {
		const checkboxes = document.querySelectorAll(
			'.frequent-DescContainer-details .product-description-input input[type="checkbox"]'
		);
	
		checkboxes.forEach(function (checkbox) {
			checkbox.addEventListener("change", function () {
				const productId = this.id.replace("product_", "");
				const descContainer = document.getElementById(
					"descContainer_" + productId
				);
	
				if (this.checked) {
					descContainer.classList.remove("frequentHidden");
					descContainer.classList.add("frequentBlock");
					descContainer.setAttribute("data-visible", "visible");
				} else {
					// If unchecked, hide the image and plus sign
					descContainer.classList.add("frequentHidden");
					descContainer.classList.remove("frequentBlock");
					descContainer.setAttribute("data-visible", "invisible");
				}
	
				let totalPrice = 0;
				const frequentImages = document.querySelectorAll(
					'.frequent-DescContainer .frequent-images[data-visible="visible"]'
				);
	
				frequentImages.forEach(function (image) {
					const frequentPrice =
						parseFloat(image.getAttribute("data-frequentprice")) || 0;
					totalPrice += frequentPrice;
				});
	
				document.querySelector(
					".frequentPrice-Button span .frequent-originalPrice"
				).innerHTML = totalPrice;
	
				const allUnchecked = Array.from(checkboxes).every(
					(checkbox) => !checkbox.checked
				);
	
				const atLeastOneUnchecked = Array.from(checkboxes).some(
					(checkbox) => !checkbox.checked
				);
				const allchecked = Array.from(checkboxes).every(
					(checkbox) => checkbox.checked
				);
	
				const frequentButtonELement = document.querySelector(
					".frequentPrice-Button"
				);
				const offerPriceElement = frequentButtonELement.querySelector(
					".frequent-offerPrice"
				);
				const higherPrice = frequentButtonELement.getAttribute("data-higher-price");
				const originalPriceElement = frequentButtonELement.querySelector(
					".frequent-originalPrice"
				);
	
				if (allchecked){
					document.querySelector(
						".frequentPrice-Button button"
					).innerHTML = `Add To Cart : <span>
												<span class="frequent-originalPrice offer-lineThrough">Rs. ${totalPrice}</span>
												</span>
												<span class="frequent-offerPrice">Rs. ${higherPrice}</span>
												`;
				}
				
				if (atLeastOneUnchecked) {
					if (offerPriceElement) {
						offerPriceElement.style.display = "none";
					}
					if (originalPriceElement) {
						originalPriceElement.classList.remove("offer-lineThrough");
					}
				} else {
					if (offerPriceElement) {
						offerPriceElement.style.display = "inline-block";
					}
					if (originalPriceElement) {
						originalPriceElement.classList.add("offer-lineThrough");
					}
				}
	
				const disabledButton = document.querySelector(
					".frequentPrice-Button button"
				);
	
				if (allUnchecked) {
					disabledButton.style.opacity = "0.5";
					disabledButton.style.pointerEvents = "none";
				} else {
					disabledButton.style.opacity = "1";
					disabledButton.style.pointerEvents = "auto";
				}
			});
		});
	
		const frequentButton = document.querySelector(".frequentPrice-Button button");
		frequentButton.addEventListener("click", myFunction);
	
		function myFunction() {
			const frequentElements = document.querySelectorAll(
				'.frequent-DescContainer .frequent-images[data-visible="visible"]'
			);
	
			const variantIdsArray = [];
			const productNamesArray = [];
			const priceArray = [];
			const productSkuArray = [];
			const productRetailPriceArray = [];
			const productMrpPriceArray = [];
			const productImageUrlArray = [];
			const productUrlArray = [];
	
			frequentElements.forEach(function (element) {
				const variantId = element.getAttribute("data-variant-id");
				const productName = element.getAttribute("data-product-name");
				const productPrice = element.getAttribute("data-frequentprice");
				const productSku = element.getAttribute("data-product-sku");
				const productRetailPrice = element.getAttribute("data-price");
				const productMrpPrice = element.getAttribute(
					"data-product-compare-at-price"
				);
				const productImageUrl = element.getAttribute("data-imageUrl");
				const productUrl = element.getAttribute("data-product-url");
	
				variantIdsArray.push(variantId);
				productNamesArray.push(productName);
				priceArray.push(productPrice);
				productSkuArray.push(productSku);
				productRetailPriceArray.push(productRetailPrice);
				productMrpPriceArray.push(productMrpPrice);
				productImageUrlArray.push(productImageUrl);
				productUrlArray.push(productUrl);
			});
	
			let productVariantObjects = [];
	
			function createVariantsObject(variantIds, productNames, prices) {
				return variantIds.map((variantId, index) => ({
					id: variantId,
					name: productNames[index],
					price: prices[index], // Include the product price
				}));
			}
	
			const variantObjects = createVariantsObject(
				variantIdsArray,
				productNamesArray,
				priceArray
			);
			productVariantObjects.push(...variantObjects);
	
			const formData = {
				items: [...productVariantObjects],
			};
	
			formData["sections"] = "cart-drawer,cart-icon-bubble,quantity-message";
			formData["sections_url"] = "/cart";
	
			let totalPrice = 0;
			let totalQuantity = 0;
			const productQuantityArray = [];
			const productNameArray = [];
	
			const productAddData = productVariantObjects.map((product) => {
				const productPrice = parseFloat(product.price);
				totalPrice += productPrice;
				totalQuantity += 1;
				productQuantityArray.push("1");
				productNameArray.push(product.name);
				return {
					id: product.id,
					name: product.name,
					price: product.price,
					quantity: 1,
				};
			});
	
			fetch(window.Shopify.routes.root + "cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(formData),
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					const frequentCartDrawerElement =
						document.querySelector("cart-notification") ||
						document.querySelector("cart-drawer");
	
					if (frequentCartDrawerElement.classList.contains("is-empty")) {
						frequentCartDrawerElement.classList.remove("is-empty");
					}
					frequentCartDrawerElement.renderContents(data);
					frequentCartDrawerElement.addFreebie();
					const clevertapData = {
						productQuantity: productQuantityArray.join(','),
						productName: productNameArray.join(','),
						productSku: productSkuArray.join(','),
						productRetailPrice: productRetailPriceArray.join(','),
						productMrpPrice: productMrpPriceArray.join(','),
						productImageUrl: productImageUrlArray.join(','),
						productUrl: productUrlArray.join(','),
					};
	
					dataLayer.push({
						event: "frequently bought add to cart",
						ecommerce: {
							currencyCode: "INR",
							add: {
								products: productAddData,
								subTotal: totalPrice,
								totalQuantity: totalQuantity,
							},
						},
						clevertap: clevertapData,
					});
				})
				.catch((error) => {
					console.error("Error:", error);
				});
		}
	};


	class customColorSwatch extends HTMLElement {
		constructor() {
			super();
			// this.addEventListener('click', this.scrollToTop);
		}

		connectedCallback() {
			let _this = this;
			let colorSwatchContainer = this.querySelectorAll('.image_container');

			colorSwatchContainer.forEach((item) => {
				item.addEventListener('click', function () {
					_this.colorSwatch(item);
					setTimeout(() => {
						window.customFunction();
					}, 2000);
				});
			});

			// this.checkAndInitSplide();
			// window.addEventListener('resize', this.checkAndInitSplide.bind(this));
			this.splideInit();
		}

		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
		checkAndInitSplide() {
			if (window.innerWidth > 750) {
				if (!this.splideInstance) {
					this.splideInit();
				}
			} else {
				if (this.splideInstance) {
					this.splideInstance.destroy();
					this.splideInstance = null;
				}
			}
		}

		// Splide init() function
		splideInit() {
			const productColorSplide = new Splide('.product_color-swatches', {
				perPage: 6,
				perMove: 1,
				pagination: false,
				padding: { right: 0 },
				arrows: true,
				gap: 10,
				breakpoints: {
					750: {
						gap: 10,
					},
				},
			});

			productColorSplide.mount();
		}

		// Color swatch logic function
		colorSwatch(item) {
			var dataUrl = item.getAttribute('data-product-url');

			// Change URL using history state
			history.replaceState(
				{
					id: 'newproduct',
					source: 'web',
				},
				'newproduct',
				'https://www.mcaffeine.com' + dataUrl,
			);

			// Fetch section id's
			var sectionIds = [];

			document.querySelectorAll('.product-section').forEach(function (element) {
				sectionIds.push(element.dataset.section);
			});

			let mainContentEl = document.getElementById('MainContent');
			let urls = [];

			const sectionsPerArray = 5;
			const totalSections = sectionIds.length;
			const totalArrays = Math.ceil(totalSections / sectionsPerArray);

			// Divide section IDs into arrays of sectionsPerArray length
			for (let i = 0; i < totalArrays; i++) {
				let startIndex = i * sectionsPerArray;
				let endIndex = startIndex + sectionsPerArray;
				let currentArray = sectionIds.slice(startIndex, endIndex);
				let currentUrl = 'https://www.mcaffeine.com' + dataUrl + '/?sections=' + currentArray.join(',');
				urls.push(currentUrl);
			}

			// Fetch data for each URL asynchronously
			var promises = urls.map((url) => fetch(url).then((y) => y.json()));

			Promise.all(promises).then((results) => {
				// Spreading Multiple response JSON into a single JSON object
				let allsections = Object.assign({}, ...results);

				// Clear the main content element
				mainContentEl.innerHTML = '';

				// Append each section to the main content element
				for (const property in allsections) {
					mainContentEl.innerHTML += allsections[property];
				}

				// window.productGallerySplide();  // Product Gallary slider Init
				window.faqInitialization(); // FAQ Initialization
				window.scrollToSection(); // scroll to section
				window.ingredientSlider(); // Ingrediant slider
				window.progressBar(); // progress bar
				// window.qtyMaxChecker(); // QTY checker function
				window.varintSwicher(); // Variant swicher
				window.moreOffers(); // more offers section
				window.shareButtonFun(); // share button section
				// window.StickyProductTabs();   // sticky Product Section Tabs
				window.judgeMeAppend(); // Judge Me appends
				window.readMoreLess();   // read more/leass Js
				window.initMobileCartObserver();
			});
		}
	}

	customElements.define('custom-color-swatch', customColorSwatch);

	const carouselElement = document.querySelector('#image-carousel-combo');

	if (carouselElement) {
		const productImageSplide = new Splide('#image-carousel-combo', {
			perPage: 4,
			perMove: 1,
			pagination: false,
			padding: { right: 40 },
			gap: 15,
			drag: 'free',
			snap: true,
			breakpoints: {
				750: {
					perPage: 3,
					gap: 15,
					padding: { right: 20 },
				},
			},
		});

		productImageSplide.mount();
	}
});

document.addEventListener('DOMContentLoaded', function () {
	window.customFunction();
});

// JavaScript code to append a div with class 'dp'
if (document.querySelector('.jdgm-rev__author-wrapper')) {
	const authorWrappers = document.querySelectorAll('.jdgm-rev__author-wrapper');
	// extract the first letter from the element and add it inside dp using innerHTML
	authorWrappers.forEach((wrapper) => {
		const authorElement = wrapper.querySelector('.jdgm-rev__author');
		const firstLetter = authorElement ? authorElement.textContent.trim().charAt(0) : '';
		const dpDiv = document.createElement('div');
		dpDiv.classList.add('dp');
		dpDiv.innerHTML = firstLetter;

		wrapper.insertBefore(dpDiv, wrapper.firstChild);
	});
}

class beautyPowered extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.splideInit();
	}

	// Splide init() function
	splideInit() {
		const beautyPoweredSplide = new Splide('.beauty-image-text-container-main', {
			perPage: 2,
			perMove: 1,
			pagination: false,
			type: 'splide',
			arrows: true,
			snap: true,
			breakpoints: {
				750: {
					arrows: true,
				},
			},
		});

		beautyPoweredSplide.mount();
	}
}

customElements.define('beauty-powered', beautyPowered);

document.addEventListener("DOMContentLoaded", () => {
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  const accordionElements = document.querySelectorAll(".pdp-content-nav-mobile__details");
  accordionElements.forEach((accordion, i) => {
    const summaryElement = accordion.querySelector('summary');
    summaryElement.addEventListener('click', () => {
      accordionElements.forEach((eachAccordion, j) => {
        if(i !== j){
          eachAccordion.removeAttribute('open');
        }
        else {
          const accordionElement = eachAccordion.querySelector("summary");
          if(!isInViewport(accordionElement)){
            const topValue = 200;
            const offsetTop = accordionElement.getBoundingClientRect().top + window.scrollY - topValue;

            window.scrollTo({
              top: offsetTop
            });
          }
        }
      })
    })
  })
})

// Frequently bought together revamp

class FrequentlyBoughtTogether extends HTMLElement {
	constructor(){
		super();
		this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		this.showCart = true;

		this.freqBoughtInputElements = this.querySelectorAll(".frequently-bought__input");
		this.freqBoughtAtcButton = this.querySelector(".frequently-bought__atc-button");
		this.freqBoughtTotalPriceElemet = this.freqBoughtAtcButton.querySelector(".frequently-bought__total-price");
		this.freqBoughtFinalPriceElement = this.freqBoughtAtcButton.querySelector(".frequently-bought__final-price");
		
		this.freqBoughtInputElements.forEach((productInput) => {
			productInput.addEventListener('change', this.onInputChange.bind(this))
		});
		this.freqBoughtAtcButton.addEventListener('click', this.addFreqBoughtProductsToCart.bind(this));
	}

	getSelectedProducts(){
		const selectedProducts = Array.from(this.freqBoughtInputElements).filter(
			(inputElement) => inputElement.checked
		);

		return selectedProducts
	}

	onInputChange(e){
		const selectedProducts = this.getSelectedProducts();
		
		const totalPrice = selectedProducts.reduce((acc, product) => acc + parseInt(product.dataset.productPrice), 0);

		if (selectedProducts.length === this.freqBoughtInputElements.length) {
			this.freqBoughtTotalPriceElemet.textContent = `Rs. ${this.freqBoughtTotalPriceElemet.dataset.totalPrice}`;
			this.freqBoughtFinalPriceElement.textContent = `Rs. ${this.freqBoughtFinalPriceElement.dataset.finalPrice}`;
			this.freqBoughtTotalPriceElemet.classList.add("strikethrough");
			this.freqBoughtTotalPriceElemet.classList.add("total-price");
			this.freqBoughtFinalPriceElement.classList.remove("hide-element");
			this.freqBoughtAtcButton.removeAttribute('disabled', false);
		}
		else if(selectedProducts.length === 0) {
			this.freqBoughtTotalPriceElemet.textContent = "Rs. 0";
			this.freqBoughtTotalPriceElemet.classList.remove("total-price");
			this.freqBoughtFinalPriceElement.classList.add("hide-element");
			this.freqBoughtAtcButton.setAttribute('disabled', true);
		}
		else{
			this.freqBoughtTotalPriceElemet.textContent = `Rs. ${totalPrice}`;
			this.freqBoughtTotalPriceElemet.classList.remove("strikethrough");
			this.freqBoughtTotalPriceElemet.classList.remove("total-price");
			this.freqBoughtFinalPriceElement.classList.add("hide-element");
			this.freqBoughtAtcButton.removeAttribute('disabled', false);
		}
	}

	addFreqBoughtProductsToCart(){
		const selectedProducts = this.getSelectedProducts();

		let items = [];
		for (const product of selectedProducts) {
      items.push({'id': product.dataset.productId, 'quantity': 1});
    }

		const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const freqBoughtData = {"items": items};

		if (this.cart) {
      freqBoughtData['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
      freqBoughtData['sections_url'] = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }

		config.body = JSON.stringify(freqBoughtData);

		fetch('/cart/add.js', config)
		.then(response => response.json())
		.then(data => {
			this.cart.renderContents(data, this.showCart);
			this.cart.addFreebie();
			this.cart.open();
			this.addDatalayerEvents()
		})
		.catch((error) => {
			console.error('Error:', error);
		})
		.finally(() => {
			if (this.cart && this.cart.classList.contains("is-empty")){
				this.cart.classList.remove("is-empty");
			}
		});
	}

	addDatalayerEvents(){
		fetch("/cart.js")
		.then(response => response.json())
		.then(data => {

			console.log(data)

			const productsData = [];
			const productQuantityArray = [];
			const productNameArray= [];
			const productSkuArray = [];
			const productRetailPriceArray = [];
			const productMrpPriceArray = [];
			const productImageUrlArray = [];
			const productUrlArray = []

			data.items.forEach((product) => {
				productsData.push({
					"id": product.id,
					"name": product.title,
					"price": Math.round(product.price / 100),
					"quantity": 1
				});

				productQuantityArray.push(1);
				productNameArray.push(product.title);
				productSkuArray.push(product.sku);
				productRetailPriceArray.push(Math.round(product.price / 100));
				productMrpPriceArray.push(Math.round(product.productMrpPriceList / 100));
				productImageUrlArray.push(product.image);
				productUrlArray.push(product.url);
			})

			const clevertapData = {
				productQuantity: productQuantityArray.join(','),
				productName: productNameArray.join(','),
				productSku: productSkuArray.join(','),
				productRetailPrice: productRetailPriceArray.join(','),
				productMrpPrice: productMrpPriceArray.join(','),
				productImageUrl: productImageUrlArray.join(','),
				productUrl: productUrlArray.join(','),
			};
			
			dataLayer.push({
				event: "frequently bought add to cart",
				ecommerce: {
					currencyCode: data.currency,
					add: {
						products: productsData,
						subTotal: Math.round(data.total_price / 100),
						totalQuantity: data.items.length,
					},
				},
				clevertap: clevertapData
			});
		})
	}
}

// PDP sticky section tabs (mobile)
document.addEventListener('DOMContentLoaded', function () {
	const priceShareWrapper = document.querySelector('.product-thumbnail-slider');
	const stickyTabs = document.querySelector('.pdp-sticky-tabs');

	if (!priceShareWrapper || !stickyTabs) return;

	const tabs = Array.from(stickyTabs.querySelectorAll('.pdp-sticky-tabs__tab'));
	const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
	let lazySectionsTriggered = false;

	function getStickyHeader() {
		return document.querySelector('.shopify-section-header-sticky');
	}

	function positionStickyTabs() {
		const header = getStickyHeader();
		stickyTabs.style.top = (header ? header.getBoundingClientRect().bottom : 0) + 'px';
	}

	// Tab targets can belong to sections the theme lazy-loads (rendered as an
	// empty <lazy-section> until it nears the viewport), so they don't exist in
	// the DOM yet when the tabs first appear. Force those sections to fetch now.
	function triggerLazySections() {
		if (lazySectionsTriggered) return;
		lazySectionsTriggered = true;

		document.querySelectorAll('lazy-section').forEach(function (lazySection) {
			if (typeof lazySection.fetchSections === 'function') {
				lazySection.fetchSections();
			}
		});

		const lazyContentObserver = new MutationObserver(refreshTabAvailability);
		lazyContentObserver.observe(document.body, { childList: true, subtree: true });

		// Lazy sections are fetched async and in batches; keep re-checking for a
		// few seconds, then give up so tabs with no matching section stay hidden.
		[500, 1500, 3000].forEach(function (delay) {
			setTimeout(function () {
				refreshTabAvailability();
				if (delay === 3000) lazyContentObserver.disconnect();
			}, delay);
		});
	}

	function refreshTabAvailability() {
		tabs.forEach(function (tab) {
			const exists = !!document.querySelector(tab.getAttribute('data-scroll-target'));
			tab.classList.toggle('pdp-sticky-tabs__tab--hidden', !exists);
		});
	}

	function showStickyTabs() {
		positionStickyTabs();
		stickyTabs.classList.add('pdp-sticky-tabs--visible');
		triggerLazySections();
	}

	function hideStickyTabs() {
		stickyTabs.classList.remove('pdp-sticky-tabs--visible');
	}

	tabs.forEach(function (tab) {
		const targetSelector = tab.getAttribute('data-scroll-target');

		tab.addEventListener('click', function () {
			const target = document.querySelector(targetSelector);

			if (!target) return;

			tabs.forEach(function (t) {
				t.classList.remove('is-active');
			});
			tab.classList.add('is-active');

			const header = getStickyHeader();
			const offset = (header ? header.getBoundingClientRect().bottom : 0) + stickyTabs.offsetHeight + 10;
			const targetTop = target.getBoundingClientRect().top + window.scrollY - offset;

			window.scrollTo({ top: targetTop, behavior: 'smooth' });
		});
	});

	const observer = new IntersectionObserver(
		function (entries) {
			if (!mobileMediaQuery.matches) {
				hideStickyTabs();
				return;
			}

			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					hideStickyTabs();
				} else if (entry.boundingClientRect.top < 0) {
					showStickyTabs();
				}
			});
		},
		{ threshold: 0 }
	);

	observer.observe(priceShareWrapper);

	window.addEventListener('resize', function () {
		if (stickyTabs.classList.contains('pdp-sticky-tabs--visible')) {
			positionStickyTabs();
		}
	});
});

customElements.define("frequently-bought-together", FrequentlyBoughtTogether)